import withHandlers from 'recompose/withHandlers';
import HeidelbergPage from './HeidelbergPage';

const enhance = withHandlers({
  handleClick: props => () =>
    props.id % 2 === 1 ? props.onIncrement() : props.onDecrement(),
});

export default enhance(HeidelbergPage);



// WEBPACK FOOTER //
// ./src/client/js/view/components/BookPreview/HeidelbergBook/HeidelbergPage/index.js